/**
 * 出力用ページネーションリストVO
 *
 * @export OutputPagenationListModel
 * @class OutputPagenationListModel
 */
export class OutputPagenationListModel {
  // 出力区分
  public OutputDiv = String('');
  // 受注コード
  public OrderCode = String('');
  // 媒体区分
  public MediumType = String('');
}
